<div class="card vw-100 p-3">
  <div class="card-header">
    <h3>Cuestionario</h3>
  </div>
  <div class="card-body">
    <form [formGroup]="sobreMiForm" (ngSubmit)="onSubmit()">
      <h4>Sobre Mí</h4>
      <div class="mb-3">
        <label for="idRef" class="form-label">ID de Referencia</label>
        <input type="text" class="form-control" id="idRef" formControlName="idRef">
      </div>
      <div class="mb-3">
        <label for="loQueMasMeGustaHacer" class="form-label">Lo que más me gusta hacer</label>
        <input type="text" class="form-control" id="loQueMasMeGustaHacer" formControlName="loQueMasMeGustaHacer">
      </div>
      <div class="mb-3">
        <label for="misPrincipalesTalentos" class="form-label">Mis principales talentos</label>
        <input type="text" class="form-control" id="misPrincipalesTalentos" formControlName="misPrincipalesTalentos">
      </div>
      <div class="mb-3">
        <label for="talentosACompartir" class="form-label">Talentos a compartir con ABAQ</label>
        <input type="text" class="form-control" id="talentosACompartir" formControlName="talentosACompartir">
      </div>
      <div class="mb-3 form-check">
        <input type="checkbox" class="form-check-input" id="experienciaConMascotas" formControlName="experienciaConMascotas">
        <label class="form-check-label" for="experienciaConMascotas">¿Tienes experiencia con mascotas?</label>
      </div>
      <div class="mb-3">
        <label for="sobreMiExperienciaConMascotas" class="form-label">Sobre mi experiencia con mascotas</label>
        <textarea class="form-control" id="sobreMiExperienciaConMascotas" formControlName="sobreMiExperienciaConMascotas"></textarea>
      </div>

      <div class="mb-3">
        <label for="numeroMascotas" class="form-label">Número de mascotas</label>
        <input type="number" class="form-control" id="numeroMascotas" formControlName="numeroMascotas" min="0">
      </div>

      @if (mascotaForms.length > 0) {
        <h4 class="mt-4">Información de Mascotas</h4>
        <div formArrayName="mascotaForms" class="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
          @for (mascotaForm of mascotaForms.controls; track $index) {
            <div class="col">
              <div class="card h-100">
                <div class="card-header">
                  <h5>Mascota {{$index + 1}}</h5>
                </div>
                <div class="card-body" [formGroupName]="$index">
                  <div class="mb-3">
                    <label [for]="'nombre' + $index" class="form-label">Nombre</label>
                    <input type="text" class="form-control" [id]="'nombre' + $index" formControlName="nombre">
                  </div>
                  <div class="mb-3">
                    <label [for]="'foto' + $index" class="form-label">Foto (URL)</label>
                    <input type="text" class="form-control" [id]="'foto' + $index" formControlName="foto">
                  </div>
                  <div class="mb-3">
                    <label [for]="'tipoMascotas' + $index" class="form-label">Tipo de mascota</label>
                    <input type="text" class="form-control" [id]="'tipoMascotas' + $index" formControlName="tipoMascotas">
                  </div>
                  <div class="mb-3 form-check">
                    <input type="checkbox" class="form-check-input" [id]="'adoptado' + $index" formControlName="adoptado">
                    <label class="form-check-label" [for]="'adoptado' + $index">¿Es adoptado?</label>
                  </div>
                  <div class="mb-3 form-check">
                    <input type="checkbox" class="form-check-input" [id]="'placaIdentificacion' + $index" formControlName="placaIdentificacion">
                    <label class="form-check-label" [for]="'placaIdentificacion' + $index">¿Tiene placa de identificación?</label>
                  </div>
                  <div class="mb-3">
                    <label [for]="'vacunacion' + $index" class="form-label">Vacunación</label>
                    <input type="text" class="form-control" [id]="'vacunacion' + $index" formControlName="vacunacion">
                  </div>
                  <div class="mb-3 form-check">
                    <input type="checkbox" class="form-check-input" [id]="'esterilizacion' + $index" formControlName="esterilizacion">
                    <label class="form-check-label" [for]="'esterilizacion' + $index">¿Está esterilizado?</label>
                  </div>
                  <div class="mb-3">
                    <label [for]="'lugarHabitacion' + $index" class="form-label">Lugar de habitación</label>
                    <select class="form-select" [id]="'lugarHabitacion' + $index" formControlName="lugarHabitacion">
                    <option selected>Seleccione un lugar</option>
                  @for (lugar of lugaresHabitacion; track $index){
                  <option value="{{ lugar }}">{{ lugar }}</option>
                  }
                </select>
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
      }

      <button type="submit" class="btn btn-primary mt-4">Enviar</button>
    </form>
  </div>
